<template>
  <div class="hot-question">
    <div class="hot-question-head">
      <div class="hot-question-head-title"><span>热门问答</span></div>
    </div>
    <div class="hot-question-list">
      <lr-link
        class="hot-question-list-item"
        v-for="item in list"
        :key="item.id"
        :to="`/learning/question/detail/id/${item.id}`"
        target="_blank"
        @click="$emit('content-click')"
      >
        <div class="hot-question-list-item-title ellipsis">
          {{ item.title }}
        </div>
        <div class="hot-question-list-item-info">
          <span class="hot-question-list-item-read"> {{ item.post_hits | crowd }}人已阅读 </span>
          <span class="hot-question-list-item-thumbs-up">
            <icon
              type="iconic_useful"
              class="hot-question-list-item-icon"
            ></icon>
            <span>{{ item.post_like }}</span>
          </span>
        </div>
      </lr-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  }
};
</script>

<style lang="scss" scoped>
.hot-question {
  width: 278px;
  background: #fff;
  &-head {
    font-size: 14px;
    position: relative;
    padding: 10px 0;
    &-title {
      height: 16px;
      line-height: 16px;
      letter-spacing: 0;
      border-left: 2px solid #545454;
      padding-left: 10px;
    }
  }
  &-list {
    margin-top: 0;
    margin-bottom: 10px;
    &-item {
      display: block;
      overflow: hidden;
      padding-bottom: 10px;
      border-bottom: 1px solid #e8e8e8;
      margin-bottom: 10px;
      width: 238px;
      &:hover {
        color: #333333;
      }
      &-title {
        color: #222226;
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        margin-bottom: 8px;
        font-weight: 500;
      }

      &-read {
        padding-right: 40px;
        color: #999999;
        font-size: 12px;
        display: inline-block;
        width: 150px;
      }

      &-thumbs-up {
        > span {
          color: #999999;
          font-size: 12px;
          display: inline-block;
        }
      }

      &-icon {
        width: 18px;
        height: 18px;
      }
    }
  }
}
</style>
